<template>
  <modal :open="internalOpen" :full-width="true" :full-height="true">
    <template #header>
      <modal-header variant="cross" @cancel="closeModal()">
        <h1>{{ $t('pages.visibility.photo.modal.title') }}</h1>
      </modal-header>
    </template>

    <div class="pt-8 h-full">
      <div class="flex flex-col justify-center w-full h-full">
          <VisibilityPhotoRating v-model:photo="internalPhoto" v-model:loading-rated="loadingRated" @rated="closeModal()" />
      </div>
    </div>
  </modal>
</template>

<script lang="ts" setup>
import {
  ref,
} from 'vue';
import { useVModel } from '@vueuse/core';
import Modal from '@utils/Modal/Modal.vue';
import ModalHeader from '@utils/Modal/ModalHeader.vue';
import VisibilityPhotoRating from '@pages/visibility/visibilityPhoto/VisibilityPhotoRating.vue';
import type { VisibilityPhoto } from '@/entities/Entities';

interface Props {
  open: boolean;
  photo: VisibilityPhoto;
}

const loadingRated = ref(false);

const emit = defineEmits(['update:open', 'update:photo', 'close']);
const props = defineProps<Props>();
const internalOpen = useVModel(props, 'open', emit);
const internalPhoto = useVModel(props, 'photo', emit);

function closeModal() {
  internalOpen.value = false;
  loadingRated.value = false;
  emit('close');
}
</script>

<style lang="scss" scoped></style>
